import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import Layout from "../../Layout/Layout";
import { useNavigate } from "react-router-dom";
import { getCurrentDate } from "../../common/Validations";
import DatePickerComponent from "./Charts/FilterComponent/DatePickerComponent";
import SupplierConstants from "../../common/SupplierConstants";
import CategoryCard from "../../Components/Cards/CategoryCard";
import {
  ArrowDownLeft,
  ArrowUpRight,
  FileSpreadsheet,
  FileText,
  Receipt,
  ShoppingCart,
} from "lucide-react";
import CompanyInvoiceList from "./Charts/CompanyInvoiceList";
import InvoiceAgingChart from "./Charts/InvoiceAgingChart";
import PurchaseRequisitionChart from "../supplier_app/Charts/PurchaseRequisitionChart";
import CollapseCard from "../../Components/Collapsecard/Collapsecard";

const Dashboard = () => {
  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  const navigateToMainPage = (page) => {
    if (page === "supplier") {
      navigate(SupplierConstants.SUPPILER_LIST);
    } else if (page === "users") {
      navigate(SupplierConstants.ADMIN_MANAGE_USER_LIST);
    } else if (page === "pr") {
      navigate(SupplierConstants.SOURCING_PURCHASE_REQUISITION_LIST);
    } else if (page === "po") {
      navigate(SupplierConstants.POCOLLABRATION_PURCHASE_ORDER_LIST);
    } else if (page === "qtn") {
      navigate(SupplierConstants.SOURCING_BUYER_QUOTATION_LIST);
    }
  };

  const [filterShow, setFilterShow] = useState(false);
  const categoryConfigs = [
    {
      title: "Purchase Order",
      queryName: "Get_PR_Count_value",
      icon: ShoppingCart,
      navigateKey: "pr",
    },
    {
      title: "Sales Order",
      queryName: "Get_Quotation_Count_value",
      icon: FileText,
      navigateKey: "qtn",
    },
    {
      title: "AP Invoices",
      queryName: "Get_APInvoice_List",
      icon: FileSpreadsheet,
      navigateKey: "po",
    },
    {
      title: "AR Invoices",
      queryName: "Get_ARInvoice_List",
      icon: Receipt,
    },
    {
      title: "Credit Memo",
      queryName: "TenderDocumentList",
      icon: ArrowDownLeft,
      navigateKey: "tnd",
      valueKey: "tenderValue",
    },
    {
      title: "Debit Memo",
      queryName: "TenderDocumentList",
      icon: ArrowUpRight,
      navigateKey: "product",
      valueKey: "tenderValue",
    },
    {
      title: "Expense Invoice",
      queryName: "TenderDocumentList",
      icon: ArrowUpRight,
      navigateKey: "product",
      valueKey: "tenderValue",
    },
  ];

  const invoiceData = [
    { name: "Reliance Industries Ltd - RIL", value: 24 },
    { name: "Tata Consultancy Services - TCS", value: 18 },
    { name: "Infosys Ltd - INFY", value: 15 },
    { name: "HDFC Bank Ltd - HDFC", value: 12 },
    { name: "Wipro Ltd - WIPRO", value: 10 },
    { name: "ICICI Bank Ltd - ICICI", value: 8 },
    { name: "Larsen & Toubro - L&T", value: 6 },
    { name: "Mahindra & Mahindra - M&M", value: 5 },
    { name: "Bharti Airtel Ltd - AIRTEL", value: 4 },
    { name: "Asian Paints Ltd - ASIAN", value: 3 },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={10} md={10}>
                <h2 className="mainTitle">
                  Dashboard -
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {getCurrentDate()}
                  </span>
                </h2>
                <p className="subText my-0">Dashboard detailed page</p>
              </Col>
              <Col xs={2} md={2}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            {filterShow && (
              <DatePickerComponent
                // getfiltereddata={handleFilterData}
                cancelAction={() => setFilterShow(!filterShow)}
              />
            )}

            <section className="section">
              <section className="section">
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="">
                    {/* <h5 className="card-title mb-3">My Category</h5> */}
                    <div className="row g-3">
                      {categoryConfigs.map((item, index) => (
                        <div
                          className="col-12 col-md-6 col-lg-3 px-2"
                          key={index}
                        >
                          <CategoryCard
                            {...item}
                            onClick={() => navigateToMainPage(item.navigateKey)}
                          />
                        </div>
                      ))}
                    </div>
                  </CollapseCard>
                </div>
              </section>

              <div className="row">
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="AP Invoice">
                    {/* <h5 className="card-title">AP Invoice</h5> */}
                    <PurchaseRequisitionChart />
                  </CollapseCard>
                </div>
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="AR Invoice">
                    {/* <h5 className="card-title">AR Invoice</h5> */}
                    <PurchaseRequisitionChart />
                  </CollapseCard>
                </div>
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="">
                    <CompanyInvoiceList data={invoiceData} />
                  </CollapseCard>
                </div>
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="">
                    <InvoiceAgingChart />
                  </CollapseCard>
                </div>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default Dashboard;
